"use strict";
exports.__esModule = true;
//# sourceMappingURL=banner.js.map